import { render, staticRenderFns } from "./DefaultImage.vue?vue&type=template&id=039de1fd&scoped=true"
import script from "./DefaultImage.vue?vue&type=script&lang=js"
export * from "./DefaultImage.vue?vue&type=script&lang=js"
import style0 from "./DefaultImage.vue?vue&type=style&index=0&id=039de1fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039de1fd",
  null
  
)

export default component.exports